module.exports = __webpack_public_path__ + "static/img/icon.98daf6e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon.png
// module id = k3R8
// module chunks = 4